module.exports = __webpack_public_path__ + "img/map-patio-boxes.8ee885c9.png";